import React from 'react';
import RelancesFoldersAndDV from './RelancesFoldersAndDV';
import SourcingFoldersAndDV from './SourcingFoldersAndDV';

const BothFoldersAndDVLayout = () => {
  return (
    <div>
      <div>
        <div style={{ marginBottom: '20px' }}>
          <h1>Relance</h1>
          <RelancesFoldersAndDV />
        </div>
        <div>
          <h1>Sourcing</h1>
          <SourcingFoldersAndDV />
        </div>
      </div>
    </div>
  );
};

export default BothFoldersAndDVLayout;